import { USER_SEARCH } from '@/config/api/api-routes';
import { http } from '@/shared/api/http';
import type { ResultApi } from '@/shared/types/result-api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { UserSearchReq, UserSearchRes } from '../models/user-search-dto';
export const QK_USERS_SEARCH = 'users-search';

const searchUsers = async (params: UserSearchReq): Promise<UserSearchRes> => {
  const response = await http.get<ResultApi<UserSearchRes>>(USER_SEARCH, { params });
  if (!response.data.data) {
    throw new Error('Failed to search users');
  }
  return response.data.data;
};

export const useUserSearch = (searchTerm = '', enabled = true) => {
  return useQuery({
    queryKey: [QK_USERS_SEARCH, searchTerm],
    queryFn: () =>
      searchUsers({
        searchTerm: searchTerm,
        page: 1,
        pageSize: 20
      }),
    enabled: enabled && (!searchTerm || searchTerm.trim().length > 2),
    staleTime: 30000,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData
  });
};
